export const services = [
  {
    id: 1,
    title: "Air Conditioning Installation",
    description: "Professional installation of all types of air conditioning systems for residential and commercial spaces. Our certified technicians ensure optimal performance and energy efficiency.",
    icon: "wind",
    features: ["Free site assessment", "Energy-efficient systems", "Professional installation", "1-year warranty"]
  },
  {
    id: 2,
    title: "Maintenance Services",
    description: "Regular maintenance packages to keep your air conditioning systems running efficiently. Prevent costly repairs with our comprehensive maintenance plans.",
    icon: "settings",
    features: ["Scheduled servicing", "Filter cleaning/replacement", "Performance optimization", "Priority support"]
  },
  {
    id: 3,
    title: "Repair Services",
    description: "Fast and reliable repair services for all air conditioning brands and models. Our experienced technicians diagnose and fix issues promptly.",
    icon: "wrench",
    features: ["24/7 emergency service", "All brands covered", "Genuine parts", "90-day repair warranty"]
  },
  {
    id: 4,
    title: "AC Rental Services",
    description: "Flexible air conditioning rental solutions for events, temporary offices, and short-term needs. Quality units with full maintenance included.",
    icon: "repeat",
    features: ["Flexible rental periods", "Delivery & installation", "Maintenance included", "Latest models available"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Lim",
    company: "Sunrise Retail Pte Ltd",
    rating: 5,
    comment: "Excellent service from start to finish. The team installed 8 units in our new retail space efficiently and professionally. Highly recommended!",
    date: "2024-01-15"
  },
  {
    id: 2,
    name: "Michael Tan",
    company: "TechHub Solutions",
    rating: 5,
    comment: "Sky Control has been maintaining our office AC systems for over 2 years. Always prompt, professional, and their maintenance plans are very reasonable.",
    date: "2024-02-20"
  },
  {
    id: 3,
    name: "Jennifer Wong",
    company: "Residential Customer",
    rating: 5,
    comment: "My aircon broke down during a heatwave. Sky Control came within 2 hours and fixed it quickly. Great emergency service!",
    date: "2024-03-10"
  },
  {
    id: 4,
    name: "David Chen",
    company: "EventPro Singapore",
    rating: 5,
    comment: "We rent portable AC units for events regularly. Sky Control always delivers on time with quality equipment. Their rental service is top-notch.",
    date: "2024-03-25"
  }
];

export const companyInfo = {
  name: "Sky Control Solution & Trading Pte Ltd",
  tagline: "Integrated Industrial Services — Process Construction, Maintenance & Manpower Supply",
  phone: "+65 8113 0354",
  email: "admin@skycon.sg",
  address: "Blk 15 Jurong West Ave 5, #02-17, Singapore 649490",
  hours: "Mon-Fri: 9AM-6PM, Sat: 9AM-1PM",
  emergencyHours: "24/7 Emergency Service Available"
};